import(/* webpackMode: "eager" */ "/app/frontend/src/app/(auth)/forgot-password/page.tsx");
